// Wiedervorlage (Snooze) + Später-senden: reine Datums-/Text-Helfer, vitest-getestet.
// Sichtbarkeits-Regel: wiedervorlage_am > jetzt = geschlummert (ausgeblendet, im
// Wiedervorlage-Ordner); <= jetzt = fällig (oben angepinnt mit Badge).

export interface DatumsPreset { label: string; datum: Date }

const umUhrzeit = (basis: Date, tageDazu: number, stunde: number): Date => {
  const d = new Date(basis.getFullYear(), basis.getMonth(), basis.getDate() + tageDazu, stunde, 0, 0, 0);
  return d;
};

export function wiedervorlagePresets(jetzt: Date): DatumsPreset[] {
  // Nächster Montag: 1..7 Tage voraus (von Montag aus = Montag nächster Woche).
  const wochentag = jetzt.getDay(); // 0 = So
  const bisMontag = ((8 - wochentag) % 7) || 7;
  return [
    { label: 'Morgen 9:00', datum: umUhrzeit(jetzt, 1, 9) },
    { label: 'In 3 Tagen 9:00', datum: umUhrzeit(jetzt, 3, 9) },
    { label: 'Nächste Woche Mo 9:00', datum: umUhrzeit(jetzt, bisMontag, 9) },
  ];
}

export function spaeterSendenPresets(jetzt: Date): DatumsPreset[] {
  const heute17 = umUhrzeit(jetzt, 0, 17);
  const presets: DatumsPreset[] = [];
  if (heute17.getTime() > jetzt.getTime()) presets.push({ label: 'Heute 17:00', datum: heute17 });
  presets.push({ label: 'Morgen 8:00', datum: umUhrzeit(jetzt, 1, 8) });
  return presets;
}

export function istGeschlummert(wiedervorlageAm: string | null | undefined, jetzt: Date): boolean {
  if (!wiedervorlageAm) return false;
  return new Date(wiedervorlageAm).getTime() > jetzt.getTime();
}

export function istWiedervorlageFaellig(wiedervorlageAm: string | null | undefined, jetzt: Date): boolean {
  if (!wiedervorlageAm) return false;
  return new Date(wiedervorlageAm).getTime() <= jetzt.getTime();
}

// Zitat-Marker der Antwort-/Weiterleitungs-Vorbelegung (EmailVerfassen).
const ZITAT_MARKER = ['--- Ursprüngliche Nachricht ---', '--- Weitergeleitete Nachricht ---'];

/**
 * Trennt den eigenen Text vom Zitat-Block — KI-Übernehmen ersetzt nur den eigenen Teil.
 * Splittet am POSITIONELL ersten Marker im Text, nicht am ersten Eintrag von ZITAT_MARKER:
 * eine Weiterleitung kann selbst eine ältere Antwort zitieren, dann steht der
 * Weiterleitungs-Marker VOR einem verschachtelten Ursprüngliche-Marker weiter unten — ein Scan
 * in fester Array-Reihenfolge (statt nach kleinstem Index) hätte fälschlich am hinteren,
 * verschachtelten Marker gesplittet und den ganzen zitierten Weiterleitungs-Header dem
 * "eigenen" Text zugeschlagen.
 */
export function teileAmZitat(text: string): { eigener: string; zitat: string | null } {
  let ersterIndex = -1;
  for (const marker of ZITAT_MARKER) {
    const i = text.indexOf(marker);
    if (i >= 0 && (ersterIndex === -1 || i < ersterIndex)) ersterIndex = i;
  }
  if (ersterIndex === -1) return { eigener: text, zitat: null };
  return { eigener: text.slice(0, ersterIndex).trimEnd(), zitat: text.slice(ersterIndex) };
}
